var _defs, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTesting = function SvgTesting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Testing_svg__fa6d7e5b-2f5b-4e95-b395-a37ab78174be{fill:none;stroke:currentColor;stroke-width:5px;stroke-linecap:round;stroke-linejoin:round}"))), /*#__PURE__*/React.createElement("g", {
    id: "Testing_svg__bc213845-0cb1-40dc-9835-0982b8ea6914",
    "data-name": "Testing"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h250v250H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.42,
    cy: 103.58,
    r: 43.5,
    style: {
      strokeMiterlimit: 10,
      stroke: "currentColor",
      strokeWidth: 5,
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Testing_svg__fa6d7e5b-2f5b-4e95-b395-a37ab78174be",
    d: "m125.01 104.48 15.67 15.67 28.01-28M115.66 134.34l-14.54 14.54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Testing_svg__fa6d7e5b-2f5b-4e95-b395-a37ab78174be",
    d: "M82 140.94h0a9.23 9.23 0 0 1 9.23 9.23v45h0-18.51 0v-45a9.23 9.23 0 0 1 9.28-9.23Z",
    transform: "rotate(-135 81.955 168.044)"
  }))));
};

export default SvgTesting;